import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormGroupDirective } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.css']
})
export class EmailConfigurationComponent implements OnInit {

  @ViewChild('modalShow') modalShow;
  @ViewChild('modalHide') modalHide;

  public userData;

  public emailObj=[];
  public filteredData = [];
  public tableData = [];
  public editEmailObj={};
  public emailForm:FormGroup;
  public searchForm:FormGroup;
  public name=this.fb.control('',[Validators.required]);
  public email=this.fb.control('',[Validators.required,Validators.email]);
  public modalTitle;
  public modalType;
  public uniqueID;
  public filterEnable:boolean=false;
  public enableTable:boolean= false;

  constructor(public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public fb: FormBuilder) { 
      this.userData = this.storage.get('userInfo')
  }

  ngOnInit(): void {
    this.addEmailForm();
    this.searchFormLoad();
    this.getEmailData();
  }
  addEmailForm(){
    this.emailForm=this.fb.group({
      name:this.fb.control('',[Validators.required]),
      emailID:this.fb.control('',[Validators.required,Validators.email,Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')]),
    });
  }
  searchFormLoad(){
    this.searchForm=this.fb.group({
     name:[''],
     emailID:[''],
    })
  }
  fieldChange(){
    this.filteredData = [ ...this.emailObj];
    this.tableData = [ ...this.emailObj];
    console.log(this.searchForm.value);
    Object.entries(this.searchForm.value).forEach(([key, value]) => {
      if (value)  this.filterNotification(key,value);  });
  }

  filterNotification(key,value){
      if (key=='name'){
        this.filteredData = this.filteredData.filter((e)=>{
          let userName = e[key].toLowerCase();
          if(userName.search(value.toLowerCase()) !=-1 )
            return e;   
          });
      }
      if (key=='emailID'){
        this.filteredData = this.filteredData.filter((e)=>{
          if(e[key].toLowerCase().search(value.toLowerCase()) != -1) return e;  });
      }
    this.tableData = [ ...this.filteredData];
  }
  resetFilter(){
    this.tableData = [ ...this.emailObj];
  }

  filterOption(field,event){
    console.log(field);
    console.log(event.target.value);
  }
  emailModal(modalType){
    if(modalType=='add'){
      this.modalTitle='Add Email';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }
    if(modalType=='edit'){
      this.modalTitle='Edit Email';
      this.modalType=modalType;
      this.modalShow.nativeElement.click();
    }
  }
  addFormValues(){
    console.log(this.emailForm.value);
    if(this.emailForm.valid){
      this.createEmail();
      this.modalClose();
    }
  }
  editFormValues(){
    if(this.emailForm.valid){
      let updateObj={};
      let key=Object.keys(this.emailForm.value);

      key.filter((item)=>{
        if(this.editEmailObj[item]!=this.emailForm.value[item]){
          updateObj[item]=this.emailForm.value[item];
        }
      })

      if (Object.keys(updateObj).length>0) this.updateEmail(updateObj);

      this.modalClose();
    }
  }
  modalClose(){
    this.modalHide.nativeElement.click();
    this.modalTitle='';
    this.modalType='';
    this.uniqueID=undefined;
    this.emailForm.reset();
  }

  resetEmailForm(formDirective:FormGroupDirective){
    formDirective.resetForm();
  }

  editEmailData(element){
    this.uniqueID=element.notificationID;
    this.patchEmailValue(element)
    this.emailModal('edit');
  }
  patchEmailValue(element){
    let obj={name:element.name,emailID:element.emailID};
    this.emailForm.patchValue(obj);
    this.editEmailObj=obj;
  }

/* get email data*/
  getEmailData() {
    const obj = {
      orgID: this.userData.orgID,
      type:"list",
      notification:"email",
    };
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.emailObj = res.data;
        this.tableData = res.data;
        this.enableTable = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
/* patch email values */
  setEmailValue(){
    console.log(this.emailObj);
  }

  onSubmit(){
    console.log(this.emailForm.value);
  }
  updateEmail(updateValues){
    let obj={
      orgID:this.userData.orgID,
      type:"update",
      notification:"email",
      notificationID:this.uniqueID,
      ...updateValues
    }
    console.log(obj);
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getEmailData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  createEmail(){
    let obj={
      orgID:this.userData.orgID,
      type:"create",
      notification:"email",
      ...this.emailForm.value,
    };
    console.log(obj);
    //let uniqueValue = this.checkUniqueEmail(obj['emailID']);
    //if(uniqueValue) this.uniqueEmailAlert();
    //else{
      this.api.transportManagerNotificationConfig(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.getEmailData();
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    //}
  }

  checkUniqueEmail(email){
    let findValue = false;
    let sameEmail = this.emailObj.find((email)=>email.emailID == email);
    if (sameEmail) findValue = true;
    return findValue
  }
  uniqueEmailAlert(){
    this.swal.swalFunction('error', 'Failure', 'Email ID already existed !', 3000);
    this.modalClose();
  }

  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteEmail(id);
        /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  deleteEmail(id){
    let obj={
      orgID: this.userData.orgID,
      type:"delete",
      notification:"email",
      notificationID:id,
    }
    console.log(obj);
    this.api.transportManagerNotificationConfig(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getEmailData();
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

}
